import React from 'react';
import { useT } from 'client/i18n/hooks/useT';

export function PodcastLaneIcon({
  width = '100%',
}: {
  width?: string | number;
}) {
  const t = useT();
  return (
    <svg
      width={width}
      viewBox="0 0 347 327"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t(
        'HomePage.PodcastLaneIcon.IconAriaLabel',
        'An illustration of a gavel and a person riding a bike, with the caption: Cycling + Defense Attorney = Stay In Your Lane',
        'Anchor podcast title suggestion image screenreader information'
      )}
      style={{ userSelect: 'none' }}
      fontFamily="Maax"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M232.15 34.6c8.37-14.05 20.9-22.13 27.97-18.04 7.07 4.08 6.02 18.78-2.36 32.82-8.37 14.05-20.9 22.13-27.96 18.05-7.08-4.08-6.02-18.78 2.35-32.83z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M236.15 36.9c9.94-16.67 26.17-25.47 36.25-19.65 10.09 5.82 10.2 24.05.26 40.73-9.94 16.67-26.17 25.47-36.25 19.65-10.08-5.81-10.2-24.05-.26-40.72z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M249.97 45.65c7.84-13.17 17.95-21.68 22.58-19.01 4.62 2.67 2 15.5-5.84 28.67-7.85 13.17-17.96 21.68-22.58 19.02-4.63-2.67-2.01-15.51 5.84-28.68zM261.64 93.02l.05-.07 15.67 6.53c-3.32 13.18-5.01 1.38-20 23.18-14.96 21.83-70.7 130.8-73.59 135.85-2.19 3.83-5.6 5.12-9.88 4.58-2.07 0-4.15-.5-5.84-1.71a8.24 8.24 0 01-3.14-3.04c-2.57-3.2-3.2-6.73-1.06-10.74 2.74-5.13 65.31-110.28 76.07-134.37 10.76-24.1.42-18.94 9.57-28.9l12.15 8.7zm-91.2 165.01l.35-.66-.36.64.01.02z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M286.14 23.16c.19.1.34.21.52.36.27.12.54.27.83.42l32.9 18.98c4.49 2.6 6.12 8.12 3.62 12.3l-29.12 48.89c-2.5 4.18-8.19 5.48-12.69 2.88l-32.88-18.98c-.27-.15-.53-.34-.8-.5-.19-.08-.37-.18-.56-.28-6.9-3.98-3.95-21.56 6.6-39.25 10.55-17.7 24.68-28.8 31.58-24.82z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M290 68.44c10.54-17.69 24.68-28.8 31.58-24.82 6.9 3.98 3.94 21.55-6.6 39.24-10.55 17.68-24.68 28.8-31.58 24.81-6.9-3.98-3.94-21.54 6.6-39.23z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M299.95 75.4c7.85-13.16 17.96-21.68 22.59-19 4.62 2.66 2 15.5-5.84 28.67-7.85 13.17-17.96 21.68-22.59 19.01-4.62-2.67-2-15.5 5.84-28.67z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M304.43 78.1c10.36-17.4 25.66-27.51 34.16-22.6 8.5 4.9 6.99 22.97-3.38 40.37-10.37 17.39-25.66 27.5-34.16 22.6-8.5-4.9-6.99-22.98 3.38-40.37z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M231.28 118.67c2.18-4.73 10.02-5.77 17.5-2.33 7.48 3.45 11.78 10.07 9.6 14.8-2.2 4.73-10.03 5.77-17.51 2.33-7.48-3.44-11.78-10.07-9.6-14.8z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <path
          d="M238.18 115.75c2.19-4.73 8.17-6.63 13.37-4.23 5.2 2.39 7.64 8.16 5.46 12.9-2.18 4.72-8.17 6.61-13.37 4.22-5.2-2.39-7.64-8.16-5.46-12.9z"
          fill="#FF8620"
          fillRule="nonzero"
        />
        <path
          d="M319.49 87.7c8.91-14.95 19.89-24.92 24.51-22.25 4.63 2.67 1.15 16.96-7.77 31.92-8.91 14.95-19.89 24.92-24.51 22.25-4.63-2.67-1.15-16.96 7.77-31.92z"
          fill="#E8F524"
          fillRule="nonzero"
        />
        <g fillRule="nonzero">
          <path
            d="M265.56 234.95a12.78 12.78 0 005.09 6.08c4 2.57 8.27 4.86 12.2 7.57.12.1.3.28.42.42-.04 2.01-.38 6.48-.43 8.48-4.52 0-8.86-1.27-13.39-1.27-1.16-6.87-2.68-14.5-3.88-21.28z"
            fill="#97E0CE"
          />
          <path
            d="M317.54 252.7c.69.29 1.38.67 2.11.92 2.28.81 4.57 1.57 6.85 2.38.82.26 1.6.55 2.42.8 1.33.52 2.71 1.07 4.05 1.58.3.12.56.25.86.38-.39.9-.73 1.78-1.12 2.67-5.48-.68-10.9-1.31-16.38-2-2.5-.29-5.04-.63-7.54-.93-.47-.84-1.25-1.6-1.42-2.54-.56-2.72-.9-5.48-1.34-8.24-.38-2.29-.77-4.58-1.25-6.83-.26-1.14-1.16-1.86-2.32-2.08-3.2-.5-6.34-.97-9.53-1.44-.21-.04-.47.04-.69.08.09.17.13.39.26.56.95 1.27 1.9 2.54 2.89 3.82-.78 1.01-1.6 2-2.37 3.01l-5.7 7.51c-1.41-.8-2.8-1.57-4.21-2.38a2.69 2.69 0 00-.4-.34c-3.91-2.41-7.8-4.92-11.8-7.25-2.33-1.36-4-3.1-5.08-5.52a9.92 9.92 0 010-6.96c1.55-3.99 4.6-6.03 8.83-6.83 8.62-1.66 17.24-3.48 25.86-5.26 3.06-.64 6.07-1.32 9.22-.6 2.24.51 4.22 1.44 5.99 2.93 1.12 1.61 2.5 3.14 3.27 4.88 1.43 3.31 1.08 6.8.13 10.14-1.25 4.46-2.67 8.92-3.96 13.37-.7 2.08.39 3.7 2.37 4.16z"
            fill="#FF8620"
          />
          <path
            d="M302.41 278.92a25.67 25.67 0 0119.65-.98 25.18 25.18 0 0116.98 23.51c.05 13.58-10.43 24.66-24.13 25.5-12.54.77-24.22-7.93-26.59-20.02-1.98-10.1 1.3-18.46 9.22-25.08.82-.73 1.81-1.24 2.76-1.87l.86 1.61c-3.57 2.12-6.46 5-8.49 8.62-5.43 9.67-3.62 21.47 4.74 28.81 7.29 6.41 15.73 7.94 24.87 4.46 8.23-3.14 13.19-9.34 14.7-17.83 1.37-7.93-.95-14.94-6.77-20.66a23.24 23.24 0 00-15.86-6.75c-3.84-.17-7.46.63-10.95 2.16-.38-.5-.69-1.02-.99-1.48z"
            fill="#5000B9"
          />
          <path
            d="M317.54 252.7c-1.98-.48-3.02-2.09-2.46-4.08 1.3-4.46 2.67-8.92 3.97-13.37.95-3.4 1.29-6.88-.13-10.14-.78-1.79-2.16-3.27-3.28-4.89 1.43-.72 2.29-.59 3.1.73 2.03 3.26 4.01 6.58 5.95 9.89a146.8 146.8 0 013.97 7.25 10 10 0 01-6.34 14.26c-1.55.47-3.19.26-4.78.34z"
            fill="#FFF"
          />
          <path
            d="M263.24 303.62a25.2 25.2 0 01-6.68 15.1c-6.94 7.56-18.4 10.32-28.01 6.54-9.61-3.82-15.17-10.86-16.38-21.05-.77-6.32.9-12.1 4.66-17.23a25 25 0 0115.04-9.85 25 25 0 0114.43.85c1.25.47 2.5 1.06 3.75 1.57-.34.51-.69 1.02-.99 1.49a24.68 24.68 0 00-9.48-2.76c-9.78-.76-19 4.33-23.27 13.11-3.88 7.77-3.45 15.54 1.2 22.88 6.99 11.03 21.6 14.09 32.5 7.51 6.98-4.24 10.73-10.53 11.46-18.55.56 0 1.12-.04 1.64-.04.04.13.09.26.13.43z"
            fill="#5000B9"
          />
          <path
            d="M249.06 281.04c.35-.51.7-1.02 1-1.49 2.23-3.52 4.52-7 6.71-10.56.95-1.53.26-3.14-.21-4.71-.13-.43-.17-.85-.26-1.28h1.47c.34.26.73.47.99.77.17.2.21.6.34.89.82 2.33 1.51 2.8 4.01 2.84 2.84.04 5.73.09 8.58.09h1.07c3.4 0 6.81-.05 10.22-.05.26.05.51.09.77.09-.43.76-.86 1.53-1.33 2.3l-11.42-.14c-2.85 0-5.65-.04-8.5-.04-1.03 0-1.37.42-1.07 1.4 1.2 3.57 2.5 7.13 3.75 10.65 1.46 4.12 2.89 8.24 4.35 12.35-.73.26-1.46.55-2.15.8l-3.1-8.9c-.65-1.83-1.26-3.65-1.9-5.48-1.04-2.97-2.07-5.94-3.15-8.87-.3-.89-.77-.97-1.25-.2-1.98 3.09-3.96 6.19-5.9 9.28-.3.51-.6.98-.86 1.49l-3.1 4.96c-.22.22-.48.43-.61.73-1.47 2.25-2.84 4.54-4.3 6.74-.79 1.15-1.6 2.25-2.42 3.4l-1.73-.9c.74-1.18 1.43-2.41 2.16-3.6 1.6-2.59 3.23-5.13 4.87-7.68.9-1.66 1.94-3.27 2.97-4.88zM302.41 278.92l.9 1.48 2.72 5.1 7.11 13.1 1.21 2.34c.39.72.52 1.45-.34 1.87-.87.42-1.3-.17-1.69-.8l-1.29-2.04c-.82-1.57-1.55-3.14-2.41-4.67-1.55-2.89-3.2-5.73-4.74-8.62-.9-1.7-1.85-3.4-2.76-5.09l-.86-1.61c-1.25-2.34-2.46-4.71-3.75-7-.47-.85-1.08-.85-1.68-.05-3.4 4.5-6.81 9.04-10.22 13.58-1.29 1.74-2.58 3.48-3.83 5.22h-.04c-.44-.68-.87-1.35-1.34-2.03 2.02-2.72 4.05-5.44 6.08-8.1.17-.22.38-.43.56-.65 4.87-6.4 9.74-12.77 14.65-19.18.17-.04.34-.08.47-.21 2.2-1.87 4.79-2.8 7.67-3.01l7.55.93c-.13.72-.22 1.44-.35 2.16-1.77-.2-3.58-.3-5.3-.59-4.18-.68-7.28 1.02-9.87 4.03-.82.98-1.5 2.04-2.28 3.06-.86 1.1-.82 2.25-.17 3.35 1.24 2.46 2.62 4.92 4 7.43z"
            fill="#FFF"
          />
          <path
            d="M267.33 295c.74-.25 1.47-.55 2.16-.8.17-.05.34-.05.56-.09l3.32.21c1.68 1.2 3.36 2.42 5.04 3.61.26.8.56 1.65.69 2.46.17 1.06.17 2.17.21 3.23 0 .25-.08.55-.21.8-1.12 2.5-2.63 4.67-5.52 5.35-4.05.98-8.1-.76-9.7-4.58-.2-.55-.43-1.06-.64-1.62l-.13-.46c0-.72.04-1.49.04-2.2l.13-.82a9.53 9.53 0 014.05-5.09zm6 7.26c0-1.15-.91-2-2.03-2-1.04 0-1.94.9-1.98 1.87a2.11 2.11 0 002.02 2.08c1.12 0 1.98-.85 1.98-1.95z"
            fill="#FF8620"
          />
          <path
            d="M269.32 255.5c4.52 0 9.09-.05 13.61-.05v12.14c-3.4 0-6.8.04-10.21.04h-1.08l-2.32-12.14z"
            fill="#E8F524"
          />
          <path
            d="M278.37 297.93c-1.69-1.19-3.37-2.42-5.05-3.6-.82-.64-1.68-1.24-2.5-1.88-1.33-2.41.87-5.34 3.06-5.64-.17 1.53.3 2.38 1.73 3.1 1.33.64 2.54.3 3.75-.21.43.68.86 1.36 1.33 2.03-.56.64-1.12 1.28-1.64 1.91-.43.56-.47 1.15.1 1.57.6.47 1.16.17 1.59-.34.38-.46.73-.93 1.07-1.44.35.51.7 1.02 1 1.53-.4.47-.91.89-1.13 1.4-.17.38-.13 1.06.13 1.36.4.46 1.04.42 1.47-.13l.77-.9c.7.6 1.38 1.24 2.12 1.8 1.37 1.1 1.37 1.77-.05 2.92-1.46-.47-2.97-.98-4.44-1.44-1.07-.6-2.2-1.32-3.31-2.04z"
            fill="#97E0CE"
          />
          <path
            d="M254.62 257.91c-1.55.09-3.19.38-4.7.13-1.68-.3-3.27-1.06-4.87-1.78-.43-.22-.77-1.06-.69-1.57.09-.47.7-.98 1.21-1.28.43-.21 1.04-.17 1.55-.17a1993.88 1993.88 0 0116.25.9c.82.12 1.5.46 1.46 1.35 0 .94-.77 1.06-1.5 1.15-2.07.21-4.1.42-6.17.68-.3.04-.6.17-.9.25-.52.13-1.08.26-1.64.34zM315.99 261.64c.13-.72.21-1.44.34-2.16 5.48.68 10.9 1.32 16.38 2 .08 0 .21.04.3.04 1.16.17 1.68.55 1.55 1.31-.09.77-.69 1.02-1.85.9l-3.75-.39c-2.07-.3-4.14-.55-6.25-.85-2.2-.25-4.44-.55-6.72-.84z"
            fill="#5000B9"
          />
          <path
            d="M329 263.38c1.25.13 2.5.22 3.75.39 1.17.12 1.77-.17 1.85-.9.09-.76-.38-1.18-1.55-1.31-.08 0-.21-.04-.3-.04.39-.9.73-1.78 1.12-2.68a3.99 3.99 0 013.36 4.2 4.23 4.23 0 01-3.7 3.78 4.26 4.26 0 01-4.53-3.43z"
            fill="#E8F524"
          />
          <path
            d="M281.73 300.1c1.46.46 2.97.97 4.44 1.44.12.55.51 1.19.34 1.61-.26.68-1 .47-1.6.25a91.65 91.65 0 00-3.1-1.06c-1.16-.42-1.29-1.06-.34-1.9.08-.13.17-.26.26-.35z"
            fill="#FF8620"
          />
          <path
            d="M328.92 256.8c-.82-.25-1.6-.54-2.42-.8.13-1.02.22-2.04.39-3.01.13-.72.52-1.32 1.38-1.15.82.17.99.77.86 1.62-.21 1.1-.17 2.24-.21 3.35z"
            fill="#5000B9"
          />
          <path
            d="M254.62 257.91c.56-.13 1.12-.21 1.68-.34.43 1.1.9 2.2 1.3 3.35.21.68.73 1.32.12 2.04h-1.46c-.52-1.65-1.08-3.35-1.64-5.05z"
            fill="#D9D9E4"
          />
          <path
            d="M281.81 293.47c-.34.47-.69.98-1.07 1.45-.44.46-1 .76-1.6.34-.6-.47-.52-1.07-.09-1.57.52-.68 1.13-1.28 1.64-1.91h.05c.38.55.73 1.14 1.07 1.7zM284.05 296.83l-.77.89c-.48.55-1.08.6-1.47.12-.26-.3-.26-.97-.13-1.35.22-.51.74-.94 1.12-1.4.43.55.87 1.14 1.25 1.74z"
            fill="#0A0F19"
          />
          <path
            d="M300.65 261.73c-4.87 6.4-9.74 12.82-14.66 19.18-.17.21-.34.43-.56.64-2.1-1.44-4.22-2.84-6.33-4.29.04-.21 0-.42.08-.63.78-1.57 1.64-3.1 2.42-4.71.3-.64.51-1.36.73-2.04.43-.77.86-1.53 1.34-2.3 1.12-1.78 2.15-3.64 3.4-5.34 1.25-1.7 2.76-3.23 4.14-4.8 1.07-1.23 1.03-1.95-.35-2.8-1.25-.76-2.45-1.57-3.66-2.33l5.69-7.51c.77-1.02 1.6-2 2.37-3.02.17.13.34.26.47.43 2.16 2.76 4.31 5.56 6.42 8.32a6.67 6.67 0 01.22 8.15c-.56 1.06-1.16 2.07-1.72 3.05z"
            fill="#E8F524"
          />
          <path
            d="M306.03 285.5l-2.71-5.1a24.3 24.3 0 0110.94-2.16c6.17.25 11.51 2.46 15.86 6.75 5.82 5.72 8.15 12.73 6.77 20.66-1.51 8.5-6.47 14.69-14.7 17.83-9.09 3.48-17.58 1.95-24.86-4.46-8.36-7.34-10.17-19.14-4.74-28.81a23.42 23.42 0 018.49-8.62c.9 1.7 1.85 3.4 2.76 5.1-4.14 2.96-7.85 6.44-8.58 13.87-.09 2.55.13 5.05 1.2 7.39.87 1.82 1.73 3.73 3.07 5.22 4.35 4.88 9.86 7 16.46 6.15 1.29-.17 2.63-.34 3.83-.76 1.17-.43 2.24-1.2 3.28-1.87 5.73-3.78 8.53-9.08 8.27-15.87a16.83 16.83 0 00-4.78-11.2 17.38 17.38 0 00-11.03-5.57c-3.24-.42-6.51-.12-9.53 1.45zM249.06 281.04l-3.1 4.84a17.49 17.49 0 00-8.15-2c-3.1.05-6.07.6-8.7 2.08-5.35 2.97-8.58 7.47-9.4 13.58-.64 4.71.6 9 3.4 12.82 2.2 2.97 5.14 5 8.67 6.2 3.28 1.1 6.6 1.27 9.91.5 3.7-.89 7.07-2.58 9.48-5.6.95-1.14 1.9-2.37 2.5-3.73.9-2 1.51-4.12 2.24-6.2.05-.08-.13-.21-.21-.34h5.69c-.74 8.02-4.49 14.3-11.47 18.55a23.9 23.9 0 01-32.49-7.51c-4.57-7.3-5-15.07-1.16-22.84a23.7 23.7 0 0123.27-13.1c3.4.25 6.55 1.22 9.52 2.75z"
            fill="#97E0CE"
          />
          <path
            d="M261.47 303.2h-5.69c-.38-.05-.77-.13-1.16-.13-3.45-.05-6.94-.05-10.38-.09-.65 0-1.25-.13-1.9-.17v-2.08c.47 0 .9-.04 1.38-.04 4 0 8.01.04 12.02.04l5.86.13 1.6.13c0 .72-.05 1.48-.05 2.2-.6-.04-1.12 0-1.68 0z"
            fill="#FFF"
          />
          <path
            d="M282.37 269.92c-.25.68-.43 1.4-.73 2.04-.77 1.57-1.6 3.14-2.41 4.7-.09.18-.05.43-.09.64-.21.3-.52.56-.69.9a850.2 850.2 0 00-4.57 8.65c-2.2.34-4.4 3.23-3.06 5.65-.25.55-.51 1.1-.81 1.65-.18.04-.35.04-.56.09-1.47-4.12-2.9-8.24-4.36-12.35.13-.38.3-.77.39-1.19a24.9 24.9 0 015.39-10.86c3.88 0 7.71.04 11.5.08z"
            fill="#E8F524"
          />
          <path
            d="M255.7 300.73a17.25 17.25 0 00-4.18-10.48 13.42 13.42 0 00-3.45-2.97l3.1-4.97c3.7 2.6 6.51 5.86 8.36 9.98a25.53 25.53 0 012.07 8.57l-5.9-.13z"
            fill="#97E0CE"
          />
          <path
            d="M240.66 298.1l1.64 2.63v2.08c-.65.8-1.34 1.61-1.94 2.42-.13.17-.18.42-.26.64l.6.12c1.25.09 2.29 1.15 2.29 2.34a2.44 2.44 0 01-2.25 2.29c-1.25.04-2.54-.85-2.54-2.04 0-.63.48-1.27.73-1.9.09-.18.18-.35.26-.56h-.6c-2.63.3-4.74-.98-5.34-3.23-.74-2.75 1.63-6.32 4.74-5.68.3.04.64 0 .94-.04.6.34 1.17.63 1.73.93zm-1.12 3.6c0-1.14-.7-1.82-1.85-1.82-1 0-1.99.85-1.99 1.78 0 1.02 1.04 2 2.11 2 .87-.04 1.73-1.02 1.73-1.95zm1.9 6.59c-.44-.26-.65-.51-.91-.51-.17 0-.52.33-.52.5.05.22.3.6.52.6.26 0 .47-.3.9-.6z"
            fill="#FF8620"
          />
          <path
            d="M261.56 300.82a25.53 25.53 0 00-2.07-8.58 24.22 24.22 0 00-8.36-9.97c.3-.5.6-.98.86-1.48a24.81 24.81 0 019.7 12.13c.04.17.13.34.21.47.48 2.2.9 4.46 1.38 6.66l-.13.8c-.51.05-1.07 0-1.6-.03z"
            fill="#5000B9"
          />
          <path
            d="M263.28 300.1c-.47-2.21-.9-4.46-1.38-6.67l1.94-6.5c.09-.29.26-.54.4-.84 1.02 2.97 2.06 5.94 3.1 8.91a9.53 9.53 0 00-4.06 5.1z"
            fill="#E8F524"
          />
          <path
            d="M273.88 286.81c1.51-2.88 3.02-5.77 4.57-8.66.17-.34.43-.59.7-.89 2.1 1.45 4.22 2.85 6.33 4.29-2.03 2.72-4.05 5.43-6.08 8.1-1.25.51-2.46.9-3.75.22-1.42-.64-1.94-1.53-1.77-3.06z"
            fill="#5000B9"
          />
          <path
            d="M313.1 298.6c1.16.14 2.28.48 2.84 1.62.52 1.06.18 2.97-.73 3.52-1.72 1.1-2.41 1.02-3.75-.04a2.8 2.8 0 01-.47-3.73l1.3 2.03c.38.64.81 1.24 1.67.81.9-.42.73-1.15.35-1.87-.4-.8-.78-1.57-1.21-2.33z"
            fill="#D6D6E4"
          />
          <path
            d="M273.32 302.26c0 1.1-.86 1.95-1.98 1.95a2.11 2.11 0 01-2.02-2.08c.04-.97.94-1.87 1.98-1.87 1.12 0 2.02.85 2.02 2zM270.82 292.5c.82.63 1.69 1.23 2.5 1.86l-2.5-1.86zM239.54 301.7c0 .98-.9 1.96-1.77 1.96-1.08 0-2.11-.98-2.11-2 0-.93.99-1.82 1.98-1.78 1.2 0 1.9.68 1.9 1.83z"
            fill="#FAFAFA"
          />
        </g>
        <text
          fontSize="20"
          fontWeight="bold"
          fill="#FFF"
          dangerouslySetInnerHTML={{
            __html: t(
              'HomePage.PodcastLaneIcon.CyclistWordMix',
              '<tspan x="0" y="19">Cyclist +</tspan><tspan x="0" y="49">Defense Attorney =</tspan>',
              'Anchor podcast title suggestion image text'
            ),
          }}
        />
        <text
          fontSize="60"
          fontWeight="800"
          letterSpacing="-.7"
          fill="#E8F524"
          dangerouslySetInnerHTML={{
            __html: t(
              'HomePage.PodcastLaneIcon.CyclistTitleIdea',
              '<tspan x="0" y="151">Stay In</tspan><tspan x="0" y="211">Your Lane</tspan>',
              'Anchor podcast title suggestion image text'
            ),
          }}
        />
      </g>
    </svg>
  );
}
